import * as React from 'react';
import { ElementLoader } from '../element-loader/element-loader';
import { SelectExpander, Footer } from 'ui/common/dialog-expander';
import { CloseButton } from 'ui';
import styles from './select-options-expander.scss';
import { KeepFocusOnElement } from '../keep-focus-on-element';
import { ExtraFooterButton } from 'ui/common/select/types';
import noop from 'lodash/noop';

export interface SelectOptionsExpanderTexts {
  loadError: string;
  notFound: string;
  done: string;
  searchRequired: string;
}

export interface SelectOptionsExpanderProps {
  onClose: () => void;
  loadingOptions: boolean;
  loadOptionsError?: boolean;
  texts: SelectOptionsExpanderTexts;
  doNotRenderExpander?: boolean;
  switchLongDescriptionAvailable: boolean;
  notEnoughInputWhenSearchRequired?: boolean;
  switchButton?: JSX.Element;
  extraFooterButton?: ExtraFooterButton;
  optionsAvailable: boolean;
  children?: React.ReactNode;
  includeDisabledCheckbox?: JSX.Element;
}

const SelectOptionsExpanderComponent: React.FC<SelectOptionsExpanderProps> = (props) => {
  const {
    onClose, loadingOptions, texts, children, loadOptionsError, includeDisabledCheckbox,
    switchLongDescriptionAvailable, switchButton, extraFooterButton, optionsAvailable
  } = props;
  const searchRequiredMessage = props.notEnoughInputWhenSearchRequired && styles.searchRequiredMessage;
  const dialogContent = (
    loadingOptions
      ? <ElementLoader />
      : children && optionsAvailable
        ? children
        : (
          <div>
            {!!includeDisabledCheckbox && <div className="row">
              <div className="col-12 text-right">
                {includeDisabledCheckbox}
              </div>
            </div>}
            <div className={`${styles.optionsMessage} ${searchRequiredMessage}`}>
              {props.notEnoughInputWhenSearchRequired ? texts.searchRequired :
                loadOptionsError ? texts.loadError : texts.notFound
              }
            </div>
          </div>
        )
  );

  if (props.doNotRenderExpander) {
    return <div className={styles.noExpander}>{dialogContent}</div>;
  }

  const hasSwitchStyles = switchLongDescriptionAvailable ? styles.hasSwitch : '';

  return (
    <SelectExpander className={`${styles.dialogExpander} ${hasSwitchStyles}`}>
      <div className={`row justify-content-end ${styles.selectHeader}`}>
        <div className="col col-auto">
          {switchLongDescriptionAvailable
            && <div className={styles.selectSwitch}>{switchButton}</div>}
        </div>
        <div className="col col-auto"><CloseButton onClick={onClose} autofocus={false} /></div>
      </div>
      <KeepFocusOnElement>
        {dialogContent}
      </KeepFocusOnElement>
      <Footer onClose={onClose} textDone={texts.done}>
        {extraFooterButton && <div className={styles.extraFooterButton}>{extraFooterButton(onClose || noop)}</div>}
      </Footer>
    </SelectExpander>
  );
};

SelectOptionsExpanderComponent.displayName = 'SelectOptionsExpander'; // Added it to fix test.
export const SelectOptionsExpander = SelectOptionsExpanderComponent;
